
// MODIFIED: 'React' is no longer needed in scope for JSX, so the import is removed.
// import React from 'react'; 

// --- Import Your SVGs as React Components ---
import { ReactComponent as DecentralizedIcon } from '../assets/images/decentralized.svg';
import { ReactComponent as ForTeamIcon } from '../assets/images/forteam.svg';
import { ReactComponent as ScaleIcon } from '../assets/images/scale.svg';
import { ReactComponent as RevolutionIcon } from '../assets/images/revolution.svg';
import { ReactComponent as CyberIcon } from '../assets/images/cyber.svg';
import { ReactComponent as DesignIcon } from '../assets/images/design.svg';
import { ReactComponent as DevIcon } from '../assets/images/dev.svg';
import { ReactComponent as TeamIcon } from '../assets/images/team.svg';
import { ReactComponent as LineGraphic } from '../assets/images/line.svg';
import { ReactComponent as EnvelopeIcon } from '../assets/images/Envelope.svg';
import bitcoinSrc from '../assets/images/bitcoin.png';
import aSrc from '../assets/images/iconA.png';
import bSrc from '../assets/images/iconB.png';
import blueSrc from '../assets/images/iconBlue.png';
import cSrc from '../assets/images/iconC.png';
import pSrc from '../assets/images/iconP.png';
import sSrc from '../assets/images/iconS.png';
import vSrc from '../assets/images/iconV.png';

// FeatureTag component (Unchanged)
const FeatureTag = ({ icon, children }) => (
    <div className="flex items-center bg-white text-gray-700 text-xs font-medium px-4 py-1.5 rounded-md border border-gray-200 shadow-sm">
        {icon}
        <span className="ml-4">{children}</span>
    </div>
);

// PillTag Component (Unchanged)
const PillTag = ({ children }) => (
    <div className="bg-gray-100 text-gray-800 text-sm px-4 py-2 rounded-full border border-gray-200">
        {children}
    </div>
);

const FeaturesSection = () => {
    const iconClass = "h-4 w-4 text-gray-500";

    const myIconArray = [
        aSrc, sSrc, pSrc, bSrc, blueSrc, vSrc, cSrc, bitcoinSrc,
    ];

    return (
        <div className="py-20 md:py-28 bg-white text-black">
            <div className="w-10/12 mx-auto px-4 sm:px-6 lg:px-12">

                {/* Header Section */}
                <div className="text-left mb-16 md:mb-20">
                    <p className='w-fit inline-block border border-[#817AF7] text-[#817AF7] rounded-full px-4 py-1 text-sm font-medium mb-6'>
                        Features
                    </p>
                    <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
                        Explore Our Feature
                    </h1>
                    <p className="text-lg text-gray-500 max-w-2xl">
                        Discover the powerful features that make our platform stand out
                    </p>
                </div>

                {/* Top Section: Stacks on mobile/tablet, 2 columns on desktop */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">

                    {/* Top Left Box: Ready to go */}
                    <div className="rounded-2xl bg-gradient-to-br from-purple-50 via-white to-purple-100 border border-gray-100 shadow-lg overflow-hidden relative">
                        <div className="pt-8 px-8">
                            <h2 className="text-2xl font-semibold mb-2">Ready to go services</h2>
                            <p className="text-gray-500 mb-8">Streamlining solutions for swift success</p>
                        </div>
                        <div
                            className="lg:w-[115%]"
                            style={{
                                maskImage: window.innerWidth >= 1024 ? 'linear-gradient(to right, black 85%, transparent 100%)' : 'none',
                                WebkitMaskImage: window.innerWidth >= 1024 ? 'linear-gradient(to right, black 85%, transparent 100%)' : 'none'
                            }}
                        >
                            <div className="flex flex-wrap gap-3 px-8 pb-8">
                                <FeatureTag icon={<DevIcon className={iconClass} />}>Powerful APIs</FeatureTag>
                                <FeatureTag icon={<DesignIcon className={iconClass} />}>For Design</FeatureTag>
                                <FeatureTag icon={<CyberIcon className={iconClass} />}>Cybersecurity</FeatureTag>
                                <FeatureTag icon={<DecentralizedIcon className={iconClass} />}>Decentralized</FeatureTag>
                                <FeatureTag icon={<TeamIcon className={iconClass} />}>Collaborative teams</FeatureTag>
                                <FeatureTag icon={<DevIcon className={iconClass} />}> Space</FeatureTag>
                                <FeatureTag icon={<RevolutionIcon className={iconClass} />}>Revolution</FeatureTag>
                                <FeatureTag icon={<ScaleIcon className={iconClass} />}>Scalability</FeatureTag>
                                <FeatureTag icon={<ForTeamIcon className={iconClass} />}>For Teams</FeatureTag>
                                <FeatureTag icon={<DecentralizedIcon className={iconClass} />}>Decentralized</FeatureTag>
                                <FeatureTag icon={<CyberIcon className={iconClass} />}>Cybersecurity</FeatureTag>
                                <FeatureTag icon={<DevIcon className={iconClass} />}>Powerful APIs</FeatureTag>
                            </div>
                        </div>
                    </div>

                    {/* Top Right Box: Growing teams */}
                    <div className="rounded-3xl border border-gray-200 bg-white shadow-xl flex flex-col justify-between min-h-[350px]">
                        <div className='px-8 pt-8 md:px-10 md:pt-10'>
                            <h2 className="text-3xl md:text-4xl font-semibold mb-2">For growing teams</h2>
                            <p className="text-gray-600 mb-8 text-base">Tailored support to give you progress</p>
                        </div>
                        <div className="flex-grow flex items-center justify-center relative my-4">
                            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                <LineGraphic className="w-full h-auto max-h-[160px] text-gray-300" />
                            </div>
                            <button className="flex items-center bg-white text-gray-800 text-sm font-medium px-6 py-3 rounded-full border border-gray-300 shadow-lg z-10 cursor-pointer hover:shadow-xl transition-shadow hover:scale-105 duration-150">
                                <EnvelopeIcon className="h-5 w-5 mr-3 text-gray-600" />
                                <span>Invite user to this team</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Bottom Section: 1 on mobile, 2 on tablet, 3 on desktop */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                    {/* Bottom Left: APIs */}
                    <div className="p-7 rounded-2xl border border-gray-200 bg-white shadow-lg flex flex-col">
                        <h3 className="text-xl font-semibold mb-3">Powerful APIs for developers</h3>
                        <p className="text-gray-500 mb-6">Seamless Integration for your company</p>
                        <div className="rounded-lg overflow-hidden mt-2 flex-grow text-xs sm:text-sm font-mono text-gray-800">
                            <pre className="whitespace-pre-wrap break-words">
                                <code>
                                    <span className="text-[#4B4C51]">{'// SPDX-License-Identifier: MIT'}</span>{"\n"}
                                    <span className="text-[#4B4C51]">pragma</span> solidity ^0.8.0;{"\n\n"}
                                    <span className="text-[#4B4C51]">import</span> <span className="text-[#63C217]">"."</span><span className="text-[#4B4C51]">/IERC20.</span><span className="text-[#6146CD]">sol</span><span className="text-[#63C217]">";</span>{"\n\n"}
                                    <span className="text-[#4B4C51]">contract</span> MyToken <span className="text-[#24ADC4]">is</span> <span className="text-[#4B4C51]">IERC20</span> {'{\n'}
                                    {'    '}<span className="text-[#4B4C51]">string</span> <span className="text-[#4B4C51]">public</span> name = <span className="text-[#63C217]">"MyToken"</span>;{"\n"}
                                    {'    '}<span className="text-[#4B4C51]">string</span> <span className="text-[#4B4C51]">public</span> symbol = <span className="text-[#63C217]">"MT"</span>;{"\n"}
                                    {'    '}<span className="text-[#4B4C51]">uint256</span> <span className="text-[#4B4C51]">public override</span> totalSupply;{"\n"}
                                    {'    '}<span className="text-[#4B4C51]">mapping</span>(<span className="text-[#24ADC4]">address</span> = <span className="text-[#6146CD]">uint256</span>) <span className="text-[#4B4C51]">public</span>{"\n"}
                                    {'        '}<span className="text-[#4B4C51]">override</span> balanceOf;{"\n"}
                                    {'    '}<span className="text-[#4B4C51]">mapping</span>(<span className="text-[#24ADC4]">address</span> = <span className="text-[#6146CD]">mapping</span>(<span className="text-[#4B4C51]">address</span> ={"\n"}
                                    {'        '}<span className="text-[#4B4C51]">uint256</span>)) <span className="text-[#4B4C51]">public</span> <span className="text-[#4B4C51]">override</span> allowance;{"\n"}
                                    {'}'}
                                </code>
                            </pre>
                        </div>
                    </div>

                    {/* Bottom Center: Blockchains */}
                    <div className="p-8 rounded-2xl border border-gray-200 bg-white shadow-lg flex flex-col">
                        <h3 className="text-xl font-semibold mb-3">The best blockchains out there</h3>
                        <p className="text-gray-500 mb-6">Pioneering paths in decentralized solutions</p>
                        <div className="flex-grow flex justify-center items-center min-h-[280px] my-4">
                            <div className="relative w-56 h-56 sm:w-64 sm:h-64">
                                {myIconArray.map((iconSrc, i) => {
                                    const numberOfIcons = myIconArray.length;
                                    const radiusPercent = 45;
                                    const centerPercent = 50;
                                    const angleStep = 360 / numberOfIcons;
                                    const startAngle = -90;
                                    const angleRad = (startAngle + angleStep * i) * (Math.PI / 180);
                                    const left = centerPercent + radiusPercent * Math.cos(angleRad) + '%';
                                    const top = centerPercent + radiusPercent * Math.sin(angleRad) + '%';
                                    return (
                                        <div
                                            key={i}
                                            className="absolute w-12 h-12 sm:w-14 sm:h-14 rounded-full border-2 border-white shadow-lg flex justify-center items-center overflow-hidden bg-white"
                                            style={{ top, left, transform: 'translate(-50%, -50%)' }}
                                        >
                                            <img
                                                src={iconSrc}
                                                alt={`Blockchain Icon ${i + 1}`}
                                                className="w-full h-full object-contain"
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Bottom Right: Web 3.0 */}
                    <div className="p-8 rounded-2xl border border-gray-200 bg-white shadow-lg">
                        <h3 className="text-xl font-semibold mb-3">Web 3.0 development</h3>
                        <p className="text-gray-500 mb-6">Crafting tomorrow's digital landscape today</p>
                        <div className="flex flex-wrap gap-3">
                            <PillTag>Web 3.0 development</PillTag>
                            <PillTag>Growth</PillTag>
                            <PillTag>APIs</PillTag>
                            <PillTag>Co-To-Market Solutions</PillTag>
                            <PillTag>Easy-to-use interface</PillTag>
                            <PillTag>Scalable</PillTag>
                            <PillTag>Fast Integrations</PillTag>
                            <PillTag>Accessibility</PillTag>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default FeaturesSection;